import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { StoreHistoryModel, StoreProductModel } from 'v2/types/StoreModel';
import { SWRKeyPagination, SWRKeyValue } from 'v2/types/swr';
import { exportFile } from 'v2/utils';

export const storeService = {
  getStoreProducts(): Promise<StoreProductModel[]> {
    return api.get('v1/admin/diamond-shop').json();
  },

  createStoreProduct(_key: string, { arg }: MutationArg<Omit<StoreProductModel, 'id'>>): Promise<StoreProductModel> {
    return api.post('v1/admin/diamond-shop', { json: arg }).json();
  },

  updateStoreProduct(
    [_key, productId]: SWRKeyValue,
    { arg }: MutationArg<Omit<StoreProductModel, 'id'>>
  ): Promise<StoreProductModel> {
    return api.put(`v1/admin/diamond-shop/${productId}`, { json: arg }).json();
  },

  deleteStoreProduct([_key, productId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/diamond-shop/${productId}`).json();
  },

  getStoreHistory([_key, page, limit]: SWRKeyPagination): Promise<Pageable<StoreHistoryModel>> {
    return api
      .get('v1/admin/shop-history', { searchParams: { page, limit, sortFields: JSON.stringify({ date: 'desc' }) } })
      .json();
  },

  exportStoreHistory(_key: string, { arg }: MutationArg<{ startDate: string; endDate: string }>) {
    return api
      .get('v1/admin/shop-history/export', {
        searchParams: arg,
      })
      .blob()
      .then((blob) => exportFile(blob, 'purchase_history'));
  },
};
